import { useTranslation } from 'react-i18next';

interface OrgChartStatusBarProps {
  zoom: number;
  nodeCount: number;
  memberCount: number;
}

export function OrgChartStatusBar({ zoom, nodeCount, memberCount }: OrgChartStatusBarProps) {
  const { t } = useTranslation('organizationUnits');

  return (
    <div
      className="flex items-center gap-2 border-t bg-background px-4 py-1.5 text-xs text-muted-foreground"
      data-testid="org-chart-status-bar"
    >
      <span>{t('orgChart.status.zoom', { value: Math.round(zoom * 100) })}</span>
      <span className="text-border">·</span>
      <span>{t('orgChart.status.nodes', { count: nodeCount })}</span>
      <span className="text-border">·</span>
      <span>{t('orgChart.status.members', { count: memberCount })}</span>
    </div>
  );
}
